import { useState } from "react";
import { toast } from "sonner";
import { X, UserPlus, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function WaRegisterCustomer({ conv, onClose, onDone }) {
    const [f, setF] = useState({ name: conv.wa_name || conv.name || "", type: "service", nipt: "", address: "", note: "" });
    const [busy, setBusy] = useState(false);
    const set = (k, v) => setF((s) => ({ ...s, [k]: v }));

    const save = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await api.post(`/admin/whatsapp/conversations/${conv.phone}/register`, f);
            toast.success("Klienti u regjistrua");
            onDone();
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Regjistrimi dështoi");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-slate-900/60 z-50 flex items-center justify-center p-4" onClick={onClose}>
            <form onSubmit={save} onClick={(e) => e.stopPropagation()} className="bg-white border border-slate-200 rounded-xl w-full max-w-md" data-testid="wa-register-modal">
                <div className="flex items-center justify-between px-5 py-3 border-b border-slate-200">
                    <div className="font-display font-black uppercase flex items-center gap-2"><UserPlus className="w-4 h-4" /> Regjistro si klient</div>
                    <button type="button" onClick={onClose}><X className="w-4 h-4" /></button>
                </div>
                <div className="p-5 grid grid-cols-2 gap-3">
                    <label className="col-span-2"><span className="label-kicker mb-1 block">Emri *</span>
                        <input required value={f.name} onChange={(e) => set("name", e.target.value)} className="input-field" data-testid="wa-register-name" /></label>
                    <label><span className="label-kicker mb-1 block">Telefoni</span>
                        <input disabled value={`+${conv.phone}`} className="input-field font-mono opacity-70" /></label>
                    <label><span className="label-kicker mb-1 block">Lloji</span>
                        <select value={f.type} onChange={(e) => set("type", e.target.value)} className="input-field" data-testid="wa-register-type">
                            <option value="service">Servis</option>
                            <option value="end_customer">Klient fundor</option>
                        </select></label>
                    <label><span className="label-kicker mb-1 block">NIPT</span>
                        <input value={f.nipt} onChange={(e) => set("nipt", e.target.value)} className="input-field" /></label>
                    <label><span className="label-kicker mb-1 block">Adresa</span>
                        <input value={f.address} onChange={(e) => set("address", e.target.value)} className="input-field" /></label>
                    <label className="col-span-2"><span className="label-kicker mb-1 block">Shënim</span>
                        <textarea rows="2" value={f.note} onChange={(e) => set("note", e.target.value)} className="input-field" /></label>
                    <p className="col-span-2 text-[11px] text-slate-500">Fotoja e profilit merret automatikisht nga WhatsApp (nëse është publike).</p>
                </div>
                <div className="flex justify-end gap-2 px-5 pb-5">
                    <button type="button" onClick={onClose} className="btn-outline">Anulo</button>
                    <button disabled={busy} className="btn-primary" data-testid="wa-register-save">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <UserPlus className="w-4 h-4" />} Regjistro</button>
                </div>
            </form>
        </div>
    );
}
